// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__hCbri","isIcon":"tag_isIcon__hZJK8"};